import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { ENGLISH } from '../models/Language';
import translationDA from './da.json';
import translationDE from './de.json';
import translationEN from './en.json';
import translationES from './es.json';
import translationFI from './fi.json';
import translationFR from './fr.json';
import translationHI from './hi.json';
import translationHU from './hu.json';
import translationIT from './it.json';
import translationJA from './ja.json';
import translationKO from './ko.json';
import translationNL from './nl.json';
import translationNO from './no.json';
import translationPL from './pl.json';
import translationPT from './pt.json';
import translationRO from './ro.json';
import translationRU from './ru.json';
import translationSK from './sk.json';
import translationSL from './sl.json';
import translationSR from './sr.json';
import translationSV from './sv.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    de: { translation: translationDE },
    es: { translation: translationES },
    fi: { translation: translationFI },
    hi: { translation: translationHI },
    hu: { translation: translationHU },
    it: { translation: translationIT },
    ja: { translation: translationJA },
    ko: { translation: translationKO },
    no: { translation: translationNO },
    pl: { translation: translationPL },
    pt: { translation: translationPT },
    ro: { translation: translationRO },
    ru: { translation: translationRU },
    sk: { translation: translationSK },
    sl: { translation: translationSL },
    sr: { translation: translationSR },
    sv: { translation: translationSV },
    fr: { translation: translationFR },
    nl: { translation: translationNL },
    da: { translation: translationDA },
  },
  lng: ENGLISH.code,
  react: {
    useSuspense: false,
  },
});

export default i18n;
